<template>
    <div class="page-customers">
        <el-dialog
                title="Добавить клиента"
                :visible.sync="addVisible"
                width="436px"
        >
            <div>
                <el-form class="m-t-10" ref="validationForm" :model="model" v-loading="loading">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="ФИО" prop="Name" :rules="[{ required: true, message: 'ФИО не заполнено' }]">
                                <el-input v-model="model.Name" placeholder="Введите ФИО"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Логин" prop="UserLogin" :rules="[{ required: true, message: 'Логин не заполнен' }]">
                                <el-input v-model="model.UserLogin" placeholder="Введите логин"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="E-mail" prop="EmailAddress" :rules="[{ required: true, message: 'E-mail не заполнен' }]">
                                <el-input v-model="model.EmailAddress" placeholder="Введите E-mail"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Компания">
                                <el-select :clearable="true" v-model="model.CompanyID" placeholder="Выберите компанию" class="w-100">
                                    <el-option
                                            v-for="item in companyDict"
                                            :key="item.ID"
                                            :label="item.Name"
                                            :multiple="false"
                                            :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="p-b-10 m-t-30">
                    <el-row :gutter="20">
                        <el-col :span="12" align="left" class="d-flex align-items-left">
                            <el-button class="m-l-20" type="link" @click="close">Закрыть</el-button>
                        </el-col>
                        <el-col :span="12" align="right" class="d-flex align-items-right">
                            <el-button type="primary" class="w-100" icon="el-icon-plus" @click="add" :loading="loading">Добавить</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>

        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :sm="24" :md="12" :lg="18" :xl="18" class="m-b-10 m-b-md-0">
                    <el-input class="w-100"
                              placeholder="Искать клиента"
                              v-model="form.SearchString"
                              v-on:change="getData"
                              clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </el-col>
                <el-col :sm="24" :md="12" :lg="6" :xl="6" align="right" class="d-flex">
                    <el-button class="w-50" type="primary" @click="handleFilter" icon="icon-search">Поиск</el-button>
                    <el-button class="w-50" @click="addForm" icon="icon-plus">Добавить</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-table v-loading="loading" :data="dataTable">
                    <el-table-column prop="Name" label="ФИО">
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                <a href="#" @click.prevent="showDetails(scope.row.ID)" class="color-black">
                                    {{ scope.row.Name }}
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="UserLogin" label="Логин" v-if="$mobile()" />
                    <el-table-column prop="EmailAddress" label="E-mail" v-if="$mobile()"/>
                    <el-table-column prop="MaxAllowedCards" label="Max Карт" v-if="$mobile()" />
                    <el-table-column prop="Description" label="Описание" v-if="$mobile()" />
                    <el-table-column prop="WalletOnline" label="Кошелек" v-if="$mobile()">
                        <template slot-scope="scope">
                            <wallet :wallet="scope.row.WalletOnline" :ownerType="0" :id="scope.row.ID" @update="getData"></wallet>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label=""
                            width="80px"
                            align="right"
                    >
                        <template slot-scope="scope">
                            <el-button @click="deleteItem(scope.row.ID)" icon="icon-trash" class="el-button--icon" size="mini" title="Удалить"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-t-20 text-center">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="form.Page"
                            :page-sizes="[10, 20, 100, 200, 300, 400]"
                            :page-size="form.PageSize"
                            layout="sizes, prev, pager, next, total"
                            :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Wallet from '@/components/Wallet'

    export default {
        components: { Wallet },
        data () {
            return {
                loading: false,
                form: {
                    From: Vue.moment().add(-30, 'days').format('DD/MM/YYYY HH:mm'),
                    To: Vue.moment().hour('23').minutes('59').format('DD/MM/YYYY HH:mm'),
                    SearchString: '',
                    Page: 1,
                    PageSize: 20
                },
                model: {},
                total: 0,
                dataTable: [],
                companyDict: [],
                addVisible: false,
                editMode: false
            }
        },
        created () {
            this.getCompanies()
            this.getData()
        },
        methods: {
            changeDate (date) {
                this.form.From = date[0]
                this.form.To = date[1]
                this.getData()
            },
            handleSizeChange (val) {
                this.form.PageSize = val
                this.getData()
            },
            handleCurrentChange (val) {
                this.form.Page = val
                this.getData()
            },
            handleFilter () {
                this.getData()
            },
            getData () {
                this.loading = true

                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Customer"
                }, this.form)

                this.$api.Main.getCustomers(request).then(response => {
                    this.loading = false
                    this.dataTable = response.Items
                    this.total = response.Total
                }).catch (() => {
                    this.loading = false
                })
            },
            getCompanies() {
                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Company",
                    OperatorName: "Admin"
                }, this.form)

                this.$api.Main.getCompanies(request).then(response => {
                    this.companyDict = response.Items
                    this.total = response.Total
                }).catch (() => {

                })
            },
            showDetails (id) {
                this.$router.push({ name: 'customerDetails', params: { id: id } })
            },
            add () {
                this.$refs['validationForm'].validate((valid) => {
                    if (valid) {
                        this.clearFormErrors('validationForm')
                        this.loading = true

                        let request = Vue.$props('AddItem', 'Customer', this.model)

                        this.$api.Main.addCustomer(request).then(response => {
                            this.loading = false

                            if (response.Result === "Success") {
                                this.resetForm()
                                this.$message({
                                    message: 'Клиент добавлен',
                                    type: 'success',
                                    res: response
                                })

                                this.addVisible = false
                                this.getData()

                                setTimeout(() => this.clearFormErrors('validationForm'), 500)
                            }
                            else {
                                this.$message({
                                    message: response.ErrorString,
                                    type: 'error',
                                    res: response
                                })
                            }
                        }).catch((error) => {
                            this.loading = false
                            this.showFormErrors(error, 'validationForm')
                        })
                    }
                })
            },
            addForm () {
                this.resetForm()
                setTimeout(() => this.clearFormErrors('validationForm'), 1)
                this.editMode = false
                this.addVisible = true
            },
            editForm (row) {
                setTimeout(() => this.clearFormErrors('validationForm'), 1)
                this.editMode = true
                this.model = {...row}
                this.addVisible = true
            },
            close() {
                this.addVisible = false
                this.resetForm()
                setTimeout(() => this.clearFormErrors('validationForm'), 500)
            },
            resetForm () {
                this.model = {
                    Name: '',
                    UserLogin: '',
                    EmailAddress: '',
                    CompanyID: ''
                }
            },
            deleteItem (id) {
                this.$confirm('Вы уверены что хотите удалить клиента?').then(() => {
                    let request = {
                        Name: "RemoveItem",
                        ItemType: "Customer",
                        ItemId: id
                    }

                    this.$api.Main.deleteCustomer(request).then(response => {
                        if (response.Result === 'Failed') {
                            this.$message({
                                message: response.ErrorString,
                                type: 'error'
                            })
                        }
                        else {
                            this.$message({
                                message: 'Клиент удален',
                                type: 'success',
                                res: response
                            })
                            this.getData()
                        }
                    })
                })
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
